import { Injectable } from '@angular/core';

@Injectable()
export class DefaultEnvVariables {
  environment = 'default';
  production = false;
  apiURL = 'https://cdllife-mobile-api.herokuapp.com';
  apiURLv2 = 'https://cdllife-social-api.herokuapp.com';
  adNetworkURL = 'https://cdllife-ad-delivery.herokuapp.com';
  eventAPIURL = 'https://cdllife-mobile-notifications.herokuapp.com';
  recaptchaURL = 'https://cdljobboard.herokuapp.com/recaptcha';
  user = null;
  openWeatherApiKey = '3abbb8358b57cb42b73f83417e96b36d';
  highwayHuntUrl = 'https://highwayhunt.cdllife.com';
  dedicatedJobsUrl = 'https://cdljobs-dev.herokuapp.com';
  forceAnalaytics = 'false';

  shareURL = 'http://m.cdllife.com/post';
  androidSenderID = '236922203077';
  mapboxglAccessToken =
    'pk.eyJ1IjoiY2RsbGlmZSIsImEiOiJjajBqdDRjMmUwMXVzMzJycWR5M2g0bDViIn0.u6LWT9oaeco7Uw6KnjvG6g';
  googleApiKey = 'AIzaSyAiiWYKq3w7XzfXnEestsLD0m-RqHSSc9M';
  giphyApiKey = 't6XNzlS1OT0DXIkAhrmSJ0GqiPvLs1Br';
  mappingAPI = 'https://cdllife-maps.herokuapp.com';
  placeUpdateThreasholdYards = 150;
  simpleEncryptionUUID = 'fb564b37-5296-4a06-bf92-c31f8e5dc734';

  branchKey = '';

  constructor() {
    if (
      (this.environment === 'fallback' || this.environment === 'default') &&
      localStorage.getItem('ENV_DEV_OVERRIDE')
    ) {
      this.apiURL = 'https://cdllife-mobile-dev.herokuapp.com';
      this.apiURLv2 = 'https://cdllife-social-api--staging.herokuapp.com';
      this.adNetworkURL = 'https://cdllife-mobile-dev.herokuapp.com';
      this.recaptchaURL = 'https://cdljobs-dev.herokuapp.com/recaptcha';
      this.eventAPIURL =
        localStorage.getItem('eventAPIURL') || this.eventAPIURL;
    }
  }
}

export let EnvVariables = DefaultEnvVariables;



// WEBPACK FOOTER //
// ./src/environments/environment.default.ts